/**
 * Kinng.app — Login pessoal do Colaborador (Profissional) no app.
 * Token guardado em `kinng.professional.token`, SEPARADO do token do
 * tenant/owner (`kinng.token`) e do admin — sessões independentes, sem
 * interferência (mesmo padrão do portal do afiliado).
 */
const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api";
const TOKEN_KEY = "kinng.professional.token";

export const professionalAuth = {
    getToken: () => { try { return localStorage.getItem(TOKEN_KEY); } catch { return null; } },
    setToken: (t) => { try { localStorage.setItem(TOKEN_KEY, t); } catch { /* ignore */ } },
    clear: () => { try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ } },
};

const req = (path, opts = {}) => {
    const headers = { "Content-Type": "application/json", ...(opts.headers || {}) };
    const token = professionalAuth.getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
    return fetch(`${API_BASE}${path}`, { ...opts, headers }).then(async (r) => {
        let data = null;
        try { data = await r.json(); } catch { /* ignore */ }
        if (!r.ok) {
            const err = new Error(
                (data && (typeof data.detail === "string" ? data.detail : data.detail?.message)) ||
                `Erro ${r.status}`,
            );
            err.status = r.status;
            throw err;
        }
        return data;
    });
};

export const professionalApi = {
    me: () => req(`/professional/me`),
    changePassword: (new_password) =>
        req(`/professional/change-password`, { method: "POST", body: JSON.stringify({ new_password }) }),
    agenda: (date) => req(`/professional/agenda${date ? `?date=${encodeURIComponent(date)}` : ""}`),
    setStatus: (appointmentId, status) =>
        req(`/professional/agenda/${appointmentId}/status`, { method: "PATCH", body: JSON.stringify({ status }) }),
    earnings: (period) => req(`/professional/earnings${period ? `?period=${encodeURIComponent(period)}` : ""}`),
};

export default professionalApi;
